import React, { useState, useCallback, useEffect } from 'react';
import { motion } from 'framer-motion';

import CloseIcon from "../../assets/images/close.png";

import { connect } from "react-redux";
import { compose } from "redux";

import { Disable } from 'react-disable';
import debounce from "lodash/debounce";

import { getUsers } from "../../store/actions/adminActions";
import { getNotificationsSettings, addNotificationUser, removeNotificationUser, editNotificationUser } from "../../store/actions/departmentActions";

import Select from 'react-select'

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};

const Toggle = ({ checked, onChange }) => {
    return (
        <label className="relative inline-block cursor-pointer">
            <input
                type="checkbox"
                className="sr-only"
                checked={checked}
                onChange={(e) => onChange(e)}
            />
            <div
                className={`w-11 h-6 flex items-center rounded-full p-1 ${checked ? 'bg-[#3b3b3b]' : 'bg-gray-300'
                    }`}
            >
                <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${checked ? 'translate-x-5' : 'translate-x-0'
                        }`}
                />
            </div>
        </label>
    );
};

const NotificationsOverlay = ({ close, department, getUsersFN, users, getNotificationsSettingsFN, addNotificationUserFN, removeNotificationUserFN, notifications_settings, editNotificationUserFN }) => {


    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('participants');
    const [editmode, setEditmode] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [editUser, setEditUser] = useState(null);



    useEffect(() => {
        getUsersFN();
        getNotificationsSettingsFN(department.department_id);
    }, []);

    //update edituser with notifications_settings
    useEffect(() => {
        if (notifications_settings && notifications_settings?.length > 0) {
            setEditUser(notifications_settings.find(option => option.user_id === editUser?.user_id));
        }
    }, [notifications_settings]);



    const usersOptions = users && users?.length > 0 ? users.map((user) => ({
        value: user.user_id,
        label: user.first_name + " " + user.last_name
    })) : [];

    const partecipantsOptions = notifications_settings?.map((participant) => ({
        value: participant.user_id,
        label: users?.find(u => u.user_id === participant.user_id)?.first_name + " " + users?.find(u => u.user_id === participant.user_id)?.last_name
    }));

    const filteredParticipants = notifications_settings?.filter(participant => {
        const user = users?.find(u => u.user_id === participant.user_id);
        if (!user) return false;

        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(searchTerm.toLowerCase());
    });


    const selectedUser_parameters = notifications_settings && notifications_settings?.length > 0 ? notifications_settings.find(participant => participant.user_id === editUser?.user_id) : null;

    //console.log(selectedUser_parameters);



    return (
        <Disable disabled={isLoading}>
            <div className="p-6 bg-white rounded-lg shadow-2xl h-[calc(100vh-380px)] flex flex-col">
                {/* Title, Tabs and Close Button */}
                <div className="flex items-center justify-between mb-6 flex-shrink-0">
                    {/* Department Info */}
                    <div className="flex items-center min-w-[120px]">
                        <div
                            title={department.name}
                            className={`flex items-center justify-center w-8 h-8 m-2 rounded-xl hover:bg-white hover:bg-opacity-20 ml-2`}
                            style={{ backgroundColor: department.color }}
                        >
                            <span className="text-white font-bold text-[10px]">{department.name
                                .split(' ')
                                .filter(word => word.toLowerCase() !== 'and')
                                .map(word => word.charAt(0).toUpperCase())
                                .slice(0, 2)
                                .join('')}
                            </span>
                        </div>
                        <span className={``}>
                            {department.name.length > 50 ? `${department.name.substring(0, 50)}...` : department.name}
                        </span>
                    </div>

                    {/* Tabs Navigation */}
                    <div className="flex-grow flex justify-start ml-4">
                        <div className="flex space-x-6">
                            {['participants', 'configuration'].map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`relative py-2 px-1 capitalize ${activeTab === tab ? 'text-[#3b3b3b]' : 'hover:text-gray-700'
                                        }`}
                                >
                                    {tab}
                                    {activeTab === tab && (
                                        <motion.div
                                            layoutId="activeTab"
                                            className="absolute bottom-0 left-0 right-0 h-1 bg-[#3b3b3b] rounded-full"
                                            initial={false}
                                            transition={{ type: "spring", stiffness: 500, damping: 30 }}
                                        />
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="flex items-center">
                        <img src={CloseIcon} alt="Close" className="w-8 h-8 cursor-pointer" onClick={close} />
                    </div>
                </div>

                {/* Tab Content */}
                <div className="flex-1 overflow-y-auto">
                    {activeTab === 'participants' && (
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.2 }}
                            className="relative"
                        >
                            {!editmode && (
                                <div className="space-y-4">
                                    <div className="flex justify-between items-center">
                                        <button
                                            className="bg-[#3b3b3b] text-white px-4 py-2 rounded-md hover:bg-opacity-90"
                                            onClick={() => setEditmode(true)}
                                        >
                                            <i className="fa fa-plus"></i> Add Participant
                                        </button>
                                        {notifications_settings && notifications_settings?.length > 0 && <div className="relative">
                                            <input
                                                type="text"
                                                placeholder="Search by name..."
                                                className="pl-8 pr-4 py-2 border rounded-md bg-gray-50 focus:outline-none focus:ring-1 focus:ring-[#3b3b3b] focus:border-[#3b3b3b]"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            <i className="fa fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                        </div>}

                                    </div>

                                    {notifications_settings && notifications_settings?.length > 0 ? (
                                        <div className="bg-gray-50 rounded-lg overflow-hidden">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className="bg-gray-100">
                                                    <tr>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {filteredParticipants && filteredParticipants?.length > 0 ? (
                                                        filteredParticipants.map((participant) => {
                                                            const user = users?.find(u => u.user_id === participant.user_id);
                                                            if (!user) return null;

                                                            return (
                                                                <tr key={participant.user_id} className="hover:bg-gray-50">
                                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                                        {user.first_name} {user.last_name}
                                                                    </td>
                                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                        {user.title || 'N/A'}
                                                                    </td>
                                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                        {user.role || 'User'}
                                                                    </td>
                                                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm">

                                                                        <button
                                                                            onClick={() => { setEditUser(participant); setActiveTab('configuration'); }}
                                                                            className="text-gray-500 hover:text-gray-900 mr-4"
                                                                        >
                                                                            <i className="fa fa-edit text-lg "></i>
                                                                        </button>


                                                                        <button
                                                                            onClick={() => { removeNotificationUserFN(department.department_id, participant.user_id); setEditmode(false); }}
                                                                            className="text-red-600 hover:text-red-900"
                                                                        >
                                                                            <i className="fa fa-trash text-lg"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                                                                No participants found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>) : (
                                        <div className="flex justify-center items-center h-full">
                                            <span className="text-gray-500">No participants found</span>
                                        </div>
                                    )}
                                </div>
                            )}

                            {editmode && (
                                <div className="relative z-10">
                                    <div className="flex flex-col gap-2 mb-4">
                                        <Select
                                            options={usersOptions}
                                            onChange={(e) => setSelectedUser(e.value)}
                                            styles={customStyles}
                                        />
                                    </div>

                                    <button className="bg-[#3b3b3b] text-white px-4 py-2 rounded-md hover:bg-opacity-90" onClick={() => { if (selectedUser) { addNotificationUserFN(department.department_id, selectedUser); setSelectedUser(null); setEditmode(false); } else { alert("Please select a user") } }}><i className="fa fa-plus"></i> Add Participant</button>

                                    <button className="bg-[#3b3b3b] text-white px-4 py-2 rounded-md hover:bg-opacity-90 ml-4" onClick={() => setEditmode(false)}><i className="fa fa-times"></i> Close Edit Mode</button>
                                </div>
                            )}
                        </motion.div>
                    )}

                    {activeTab === 'configuration' && (
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.2 }}
                        >
                            <div className="relative z-10">
                                <div className="flex flex-col gap-2 mb-4">
                                    <Select
                                        options={partecipantsOptions}
                                        onChange={(e) => setEditUser(notifications_settings.find(option => option.user_id === e.value))}
                                        styles={customStyles}
                                        value={partecipantsOptions.find(option => option.value === editUser?.user_id)}
                                        placeholder="Select a participant.."
                                    />
                                </div>


                                {editUser && <div className="bg-gray-50 rounded-lg overflow-hidden">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-100">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Occasion</th>
                                                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">E-mail</th>
                                                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">App notification</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Assign task
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_assign_task}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_assign_task = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Deadline -5/+5 days
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_deadline}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_deadline = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Comment
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_comment}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_comment = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Delete risk
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_delete_risk}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_delete_risk = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                    <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Delete control
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_delete_control}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_delete_control = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                    <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Delete action
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_delete_action}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_delete_action = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, notify_delete_action, editUser.notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                    <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                    Modify timeline for actions
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                        <Toggle
                                                            checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_modify_timeline}
                                                            onChange={(e) => {
                                                                if (!editUser) {
                                                                    alert("Please select a user");
                                                                    return;
                                                                }
                                                                const notify_modify_timeline = e.target.checked;
                                                                editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, notify_modify_timeline);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    <div className="flex justify-center items-center">
                                                    <Toggle
                                                            checked={false}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>}



                            </div>
                        </motion.div>
                    )}
                </div>
            </div>
        </Disable >
    );
};



const mapStateToProps = (state) => {
    return {
        users: state.admin.admin_users,
        notifications_settings: state.department.notifications_settings
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUsersFN: () => dispatch(getUsers()),
        getNotificationsSettingsFN: (department_id) => dispatch(getNotificationsSettings(department_id)),
        addNotificationUserFN: (department_id, user_id) => dispatch(addNotificationUser(department_id, user_id)),
        removeNotificationUserFN: (department_id, user_id) => dispatch(removeNotificationUser(department_id, user_id)),
        editNotificationUserFN: (department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline) => dispatch(editNotificationUser(department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline))
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(NotificationsOverlay);